"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Entity_1 = __importDefault(require("../../Core/Entity"));
var PubSubEvents_1 = require("../../Services/PubSubEvents");
var Version;
(function (Version) {
    Version["v1"] = "v1";
})(Version || (Version = {}));
var BaseRoute = '/analytics-service';
var createRoute = function (route, version) {
    if (version === void 0) { version = Version.v1; }
    return "".concat(BaseRoute, "/").concat(version).concat(route);
};
var DeprecatedRoutes = {
    CREATE_REPORT: createRoute('/reports'),
    UPDATE_REPORT: createRoute('/reports/{:reportId}'),
    DELETE_REPORT: createRoute('/reports/{:reportId}'),
    START_EXPORT_REPORT: createRoute('/reports/{:reportId}/start-export'),
    START_DOWNLOAD_REPORT: createRoute('/reports/{:reportId}/start-download'),
    RETRY_EXECUTION_REPORT: createRoute('/report-executions/{:executionId}/retry')
};
var Routes = {
    GET_USER_REPORTS: createRoute('/user-reports'),
    GET_SYSTEM_REPORTS: createRoute('/system-reports'),
    CREATE_SCHEDULE_JOB: createRoute('/scheduled-jobs'),
    UPDATE_SCHEDULE_JOB: createRoute('/scheduled-jobs/{:jobId}'),
    GET_SCHEDULE_JOB: createRoute('/scheduled-jobs/{:jobId}'),
    DELETE_SCHEDULE_JOB: createRoute('/scheduled-jobs/{:jobId}'),
    IS_WEBHOOK_USED_IN_SCHEDULED_JOBS: createRoute('/scheduled-jobs/webhook/{:webhookUuid}/is-used'),
    GET_ACTIVE_REPORT_EXECUTIONS: createRoute('/report-executions/active'),
    REMOVE_EXECUTION_REPORT: createRoute('/report-executions/{:executionId}'),
    RETRY_USER_REPORT_EXECUTION: createRoute('/report-executions/user/{:executionId}/retry'),
    RETRY_SYSTEM_REPORT_EXECUTION: createRoute('/report-executions/system/{:executionId}/retry'),
    SHARE_REPORT: createRoute('/reports/{:reportId}/shares'),
    UPDATE_REPORT_SHARES: createRoute('/reports/{:reportId}/shares/{:reportShareId}'),
    DELETE_REPORT_SHARES: createRoute('/reports/{:reportId}/shares/{:reportShareId}'),
    DELETE_ALL_REPORT_SHARES: createRoute('/reports/{:reportId}/shares'),
    OPT_OUT_SHARES: createRoute('/user-reports/{:reportId}/opt-out'),
    GET_REPORT: createRoute('/reports/{:reportId}'),
    // TODO: remove with FF "hide_url_option_in_scheduled_reports_share"
    // https://bringg.atlassian.net/browse/BRNGG-44291
    GET_API_LINK: createRoute('/api-link'),
    GET_REPORT_ROWS_COUNT: createRoute('/report-query/rows-count')
};
var AnalyticsReportsEntity = /** @class */ (function (_super) {
    __extends(AnalyticsReportsEntity, _super);
    function AnalyticsReportsEntity(session) {
        return _super.call(this, {
            session: session,
            entityName: 'analytics-service'
        }) || this;
    }
    AnalyticsReportsEntity.prototype.getReport = function (reportId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.get(Routes.GET_REPORT).withRouteParams({ reportId: reportId }).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AnalyticsReportsEntity.prototype.getUserReports = function (queryString) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.get(Routes.GET_USER_REPORTS).withQueryString(queryString).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AnalyticsReportsEntity.prototype.getSystemReports = function (queryString) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.get(Routes.GET_SYSTEM_REPORTS).withQueryString(queryString).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AnalyticsReportsEntity.prototype.createReportScheduledJob = function (queryParams) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.post(Routes.CREATE_SCHEDULE_JOB).withPayload(queryParams).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AnalyticsReportsEntity.prototype.updateReportScheduledJob = function (jobId, queryParams) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .put(Routes.UPDATE_SCHEDULE_JOB)
                            .withRouteParams({ jobId: jobId })
                            .withPayload(queryParams)
                            .invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AnalyticsReportsEntity.prototype.getReportScheduledJob = function (jobId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.get(Routes.GET_SCHEDULE_JOB).withRouteParams({ jobId: jobId }).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AnalyticsReportsEntity.prototype.deleteReportScheduledJob = function (jobId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.delete(Routes.DELETE_SCHEDULE_JOB).withRouteParams({ jobId: jobId }).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AnalyticsReportsEntity.prototype.isWebhookUsedInScheduledJobs = function (webhookUuid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .get(Routes.IS_WEBHOOK_USED_IN_SCHEDULED_JOBS)
                            .withRouteParams({ webhookUuid: webhookUuid })
                            .invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    // TODO: remove with FF "hide_url_option_in_scheduled_reports_share"
    // https://bringg.atlassian.net/browse/BRNGG-44291
    AnalyticsReportsEntity.prototype.getApiLink = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.get(Routes.GET_API_LINK).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AnalyticsReportsEntity.prototype.getActiveReportExecutions = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.get(Routes.GET_ACTIVE_REPORT_EXECUTIONS).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AnalyticsReportsEntity.prototype.subscribeReportExecutions = function (handler) {
        this.service.session.persistentConnection.subscribe(new PubSubEvents_1.PubSubEvent('report_export_progress'), handler);
    };
    AnalyticsReportsEntity.prototype.unsubscribeReportExecutions = function () {
        this.service.session.persistentConnection.unsubscribe(new PubSubEvents_1.PubSubEvent('report_export_progress'));
    };
    AnalyticsReportsEntity.prototype.removeReportExecutions = function (executionId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .delete(Routes.REMOVE_EXECUTION_REPORT)
                            .withRouteParams({ executionId: executionId })
                            .invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AnalyticsReportsEntity.prototype.getReportRowsCount = function (queryJson, timeZone) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .post(Routes.GET_REPORT_ROWS_COUNT)
                            .withPayload({ queryJson: queryJson, timeZone: timeZone })
                            .invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AnalyticsReportsEntity.prototype.optOutReport = function (reportId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.delete(Routes.OPT_OUT_SHARES).withRouteParams({ reportId: reportId }).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @deprecated Use createUserReport() instead
     */
    AnalyticsReportsEntity.prototype.createReport = function (report) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.post(DeprecatedRoutes.CREATE_REPORT).withPayload(report).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @deprecated Use updateUserReport() instead
     */
    AnalyticsReportsEntity.prototype.updateReport = function (reportId, report) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .put(DeprecatedRoutes.UPDATE_REPORT)
                            .withRouteParams({ reportId: reportId })
                            .withPayload(report)
                            .invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @deprecated Use deleteUserReport() instead
     */
    AnalyticsReportsEntity.prototype.deleteReport = function (reportId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .delete(DeprecatedRoutes.DELETE_REPORT)
                            .withRouteParams({ reportId: reportId })
                            .invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @deprecated Use exportUserReport() or exportSystemReport() instead
     */
    AnalyticsReportsEntity.prototype.exportReport = function (reportId, queryParams) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .post(DeprecatedRoutes.START_EXPORT_REPORT)
                            .withRouteParams({ reportId: reportId })
                            .withPayload(queryParams)
                            .invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @deprecated Use downloadUserReport() or downloadSystemReport() instead
     */
    AnalyticsReportsEntity.prototype.downloadReport = function (reportId, queryParams) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .post(DeprecatedRoutes.START_DOWNLOAD_REPORT)
                            .withRouteParams({ reportId: reportId })
                            .withPayload(queryParams)
                            .invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @deprecated Use retryUserReportExecutions() or retrySystemReportExecutions() instead
     */
    AnalyticsReportsEntity.prototype.retryReportExecutions = function (executionId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .post(DeprecatedRoutes.RETRY_EXECUTION_REPORT)
                            .withRouteParams({ executionId: executionId })
                            .invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return AnalyticsReportsEntity;
}(Entity_1.default));
exports.default = AnalyticsReportsEntity;
//# sourceMappingURL=AnalyticsReportsEntity.js.map